var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBooking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 7.49996C2.32906 7.49996 2.96494 7.76335 3.43378 8.23219C3.90262 8.70103 4.16602 9.33692 4.16602 9.99996C4.16602 10.663 3.90262 11.2989 3.43378 11.7677C2.96494 12.2366 2.32906 12.5 1.66602 12.5V14.1666C1.66602 14.6087 1.84161 15.0326 2.15417 15.3451C2.46673 15.6577 2.89065 15.8333 3.33268 15.8333H16.666C17.108 15.8333 17.532 15.6577 17.8445 15.3451C18.1571 15.0326 18.3327 14.6087 18.3327 14.1666V12.5C17.6696 12.5 17.0338 12.2366 16.5649 11.7677C16.0961 11.2989 15.8327 10.663 15.8327 9.99996C15.8327 9.33692 16.0961 8.70103 16.5649 8.23219C17.0338 7.76335 17.6696 7.49996 18.3327 7.49996V5.83329C18.3327 5.39127 18.1571 4.96734 17.8445 4.65478C17.532 4.34222 17.108 4.16663 16.666 4.16663H3.33268C2.89065 4.16663 2.46673 4.34222 2.15417 4.65478C1.84161 4.96734 1.66602 5.39127 1.66602 5.83329V7.49996Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 4.16663V5.83329",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 14.1666V15.8333",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 9.16663V10.8333",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBooking);
export default __webpack_public_path__ + "static/media/blue_booking.dfc1de4bdd9833a92a3480bec9c16fe9.svg";
export { ForwardRef as ReactComponent };